import i18next from 'i18next';
import { CallAttempt } from 'infrastructure/enums';

export interface ICallAttemptItem {
  id: CallAttempt | null;
  name: string;
}

export const callAttemptItemDataSource = (
  withAll?: boolean,
): ICallAttemptItem[] => {
  const dataSource: ICallAttemptItem[] = [
    {
      id: CallAttempt.Zero,
      name: i18next.t('callAttempt.zero'),
    },
    {
      id: CallAttempt.One,
      name: i18next.t('callAttempt.one'),
    },
    {
      id: CallAttempt.Two,
      name: i18next.t('callAttempt.two'),
    },
    {
      id: CallAttempt.ThreePlus,
      name: i18next.t('callAttempt.threePlus'),
    },
  ];

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
